import { Tooltip } from 'antd'
import React from 'react'

const ResumeDownload = () => {
  return (
    <Tooltip title ="Download CV">
    <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d_19483_35751)">
    <rect x="2" y="1" width="38" height="38" rx="5" fill="#FBFAFF"/>
    <rect x="2.5" y="1.5" width="37" height="37" rx="4.5" stroke="#E3DEFF"/>
    <path d="M28.2105 10.6755V20.1418H26.4272V10.6755C26.4272 10.4589 26.2516 10.2832 26.0349 10.2832H12.2123C11.9965 10.2832 11.82 10.4589 11.82 10.6755V29.3245C11.82 29.5411 11.9965 29.7168 12.2123 29.7168H22.8064L24.5896 31.5H12.2123C11.0131 31.5 10.0367 30.5237 10.0367 29.3245V10.6755C10.0367 9.47631 11.0131 8.5 12.2123 8.5H26.0349C27.235 8.5 28.2105 9.47631 28.2105 10.6755Z" fill="#3249D7"/>
    <path d="M28.2104 26.7879V22.1132H26.4272V26.7879H22.5844L27.2965 31.5L31.9632 26.7879H28.2104Z" fill="#3249D7"/>
    <path d="M19.124 19.0014C20.1935 19.0014 21.0605 18.1344 21.0605 17.0648C21.0605 15.9953 20.1935 15.1282 19.124 15.1282C18.0544 15.1282 17.1874 15.9953 17.1874 17.0648C17.1874 18.1344 18.0544 19.0014 19.124 19.0014Z" fill="#3249D7"/>
    <path d="M14.4191 21.7253V23.767H23.8282V21.7253C23.8282 20.9005 23.1595 20.2318 22.3348 20.2318H15.9134C15.0887 20.2318 14.42 20.9005 14.42 21.7253H14.4191Z" fill="#3249D7"/>
    </g>
    <defs>
    <filter id="filter0_d_19483_35751" x="0" y="0" width="42" height="42" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feOffset dy="1"/>
    <feGaussianBlur stdDeviation="1"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"/>
    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_19483_35751"/>
    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_19483_35751" result="shape"/>
    </filter>
    </defs>
    </svg>
    </Tooltip>
  )
}

export default ResumeDownload